import { useUnit } from 'effector-react';
import { useNavigate, useSearchParams } from 'react-router';
import { Stack } from '@mantine/core';
import { useSearchParamsSync } from '~/shared/lib/hooks/useSearchParamsSync';
import { TradersList, TradersFilter, $tradersFilter, setTradersFilter } from './components';
import { createPayoutTraderUrl, getPayoutTradersSearchParams } from './lib';
import { paginationModel } from './model';

export const Traders = () => {
    const filters = useUnit($tradersFilter);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { traderName, bankAccountId } = getPayoutTradersSearchParams(searchParams);

    useSearchParamsSync((value) => {
        setTradersFilter({
            traderName: { value },
            statuses: undefined,
            workingStatuses: undefined,
        });
        paginationModel.setPage(0);
    }, traderName);

    useSearchParamsSync((value) => {
        setTradersFilter({
            bankAccountId: value,
            statuses: undefined,
            workingStatuses: undefined,
        });
        paginationModel.setPage(0);
    }, bankAccountId);

    return (
        <Stack gap='sm'>
            <TradersFilter />

            <TradersList
                filter={filters}
                paginationModel={paginationModel}
                onClick={(trader) => {
                    if (trader.id?.value) {
                        navigate(createPayoutTraderUrl(trader.id.value));
                    }
                }}
            />
        </Stack>
    );
};
